import { apiFetch } from '~/api/client'
import type { CatalogChecklistItem } from '~/api/types'

export interface ListCatalogChecklistParams {
    scale?: string
    classification?: string
    industry?: string
}

/** 적재된 체크리스트 카탈로그를 조회한다. */
export function listCatalogChecklist(
    params: ListCatalogChecklistParams = {}
): Promise<CatalogChecklistItem[]> {
    const query = new URLSearchParams()
    if (params.scale) query.set('scale', params.scale)
    if (params.classification) {
        query.set('classification', params.classification)
    }
    if (params.industry) query.set('industry', params.industry)

    const suffix = query.size > 0 ? `?${query.toString()}` : ''
    return apiFetch<CatalogChecklistItem[]>(`/catalog/checklist${suffix}`)
}
